<h2 mat-dialog-title class="matDialogTitle">
  {{ dialogTitles.EDIT_PERSONAL_DETAILS }}
</h2>
<mat-dialog-content>
  <form [formGroup]="detailsForm" class="detailsForm">
    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="detailsFormFields"
    >
      <mat-label class="matDialogMatLabel"> Contact number </mat-label>
      <input
        matInput
        type="text"
        class="matDialogInput"
        formControlName="contactNumber"
      />
      @if (detailsForm.get("contactNumber")?.hasError("required")) {
        <mat-error class="matError">
          *Contact number {{ errorMessages.REQUIRED }}
        </mat-error>
      }
      @if (detailsForm.get("contactNumber")?.hasError("pattern")) {
        <mat-error class="matError">
          {{ errorMessages.INVALID_CONTACT_NUMBER }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="detailsFormFields"
    >
      <mat-label class="matDialogMatLabel"> Address line 1 </mat-label>
      <input
        matInput
        type="text"
        class="matDialogInput"
        formControlName="address"
      />
      @if (detailsForm.get("address")?.hasError("required")) {
        <mat-error class="matError">
          *Address line 1 {{ errorMessages.REQUIRED }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="detailsFormFields"
    >
      <mat-label class="matDialogMatLabel"> Surburb/district </mat-label>
      <input
        matInput
        type="text"
        class="matDialogInput"
        formControlName="suburb"
      />
      @if (detailsForm.get("suburb")?.hasError("required")) {
        <mat-error class="matError">
          *Suburb {{ errorMessages.REQUIRED }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="detailsFormFields"
    >
      <mat-label class="matDialogMatLabel"> City/town </mat-label>
      <input
        matInput
        type="text"
        class="matDialogInput"
        formControlName="city"
      />
      @if (detailsForm.get("city")?.hasError("required")) {
        <mat-error class="matError">
          *City/town {{ errorMessages.REQUIRED }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="detailsFormFields"
    >
      <mat-label class="matDialogMatLabel"> Postal code </mat-label>
      <input
        matInput
        type="text"
        class="matDialogInput"
        formControlName="code"
      />
      @if (detailsForm.get("code")?.hasError("required")) {
        <mat-error class="matError">
          *Postal code {{ errorMessages.REQUIRED }}
        </mat-error>
      }
      @if (detailsForm.get("code")?.hasError("pattern")) {
        <mat-error class="matError">
          {{ errorMessages.INVALID_POSTAL_CODE }}
        </mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-flat-button mat-dialog-close color="accent">Cancel</button>
  <button
    mat-flat-button
    mat-dialog-close
    (click)="onSubmit()"
    [disabled]="!detailsForm.valid"
    color="primary"
  >
    Update personal information
  </button>
</mat-dialog-actions>
